import { Observable, Subject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { DialogId } from '@bca-shared/models/_types';

export class DialogRef<T> {
  constructor(
    public instance: T,
    public readonly identifier: DialogId,
    private _afterClosed: Subject<void>,
    private _beforeClosed: Subject<T>,
    private _backdropClicked: Subject<void>,
    private _escapeKeyPressed: Subject<void>,
    private _close: () => void
  ) {
    this.afterClosed()
      .pipe(takeWhile(() => this.instance != null))
      .subscribe(() => (this.instance = null));
  }

  afterClosed(): Observable<void> {
    return this._afterClosed.asObservable();
  }

  beforeClosed(): Observable<T> {
    return this._beforeClosed.asObservable();
  }

  backdropClicked(): Observable<void> {
    return this._backdropClicked.asObservable();
  }

  escapeKeyPressed(): Observable<void> {
    return this._escapeKeyPressed.asObservable();
  }

  close(): void {
    this._close();
  }
}
